import * as React from 'react'

type SubmitButtonProps = {
  enabled: boolean
  className: string
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  name: string
  value?: string
  content: string
}

export default function SubmitButton({ enabled, className, onClick, name, value = '', content }: SubmitButtonProps) {
  if (!enabled) {
    return null
  }

  return (
    <button type="submit" onClick={onClick} className={className} name={name} value={value}>
      {content}
    </button>
  )
}
